<template>
  <div class="modal-title">
    <h3>Bedankt voor je feedback!</h3>
  </div>
  <div class="component-spacing-bottom">
    <div
      v-if="frankStore.submitted && frankStore.positive"
      class="intro-large"
    >
      <p class="subtitle-small">
        We zijn blij dat we je hebben kunnen helpen.
      </p>
      <p>Wist je dat je via Keuze.nl ook op andere vaste lasten kan besparen? Wellicht heb je iets aan de onderstaande pagina's.</p>
    </div>
    <div
      v-else-if="frankStore.submitted && !frankStore.positive"
      class="intro-large"
    >
      Bedankt voor je feedback!
    </div>
  </div>
  <div class="alternative-links">
    <a
      v-if="frankStore.comparer !== 'internet'"
      href="/internet"
      class="link-element bordered"
    >
      <div class="label">Internet</div>
      <Icon icon="arrow-right-long-solid" />
    </a>
    <a
      v-if="frankStore.comparer !== 'energy'"
      href="/"
      class="link-element bordered"
    >
      <div class="label">Energie</div>
      <Icon icon="arrow-right-long-solid" />
    </a>
    <a
      href="/telefoon-abonnement"
      class="link-element bordered"
    >
      <div class="label">Mobiel</div>
      <Icon icon="arrow-right-long-solid" />
    </a>
    <a
      href="/private-lease"
      class="link-element bordered"
    >
      <div class="label">Private lease</div>
      <Icon icon="arrow-right-long-solid" />
    </a>
  </div>

  <div class="navigation-bar component-spacing-top">
    <ButtonIconLeft
      type="ghost"
      label="Terug naar de vergelijker"
      @click.native="frankStore.closeFrank()"
    />
    <a
      href="/"
      class="btn primary"
    >
      <span class="label">Naar de homepage</span>
      <Icon icon="arrow-right-long-solid" />
    </a>
  </div>
</template>

<script setup>
import { useFrankStore } from './store/frankStore.js';
import Icon from '../../../abstracts/elements/icon/Icon.vue';
import ButtonIconLeft from '../../../abstracts/elements/button/icon-left/button-icon-left.vue';

const frankStore = useFrankStore();

</script>
